import { render, staticRenderFns } from "./rechargeRecord.vue?vue&type=template&id=67c00e56&scoped=true&"
import script from "./rechargeRecord.vue?vue&type=script&lang=js&"
export * from "./rechargeRecord.vue?vue&type=script&lang=js&"
import style0 from "./rechargeRecord.vue?vue&type=style&index=0&id=67c00e56&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c00e56",
  null
  
)

export default component.exports